import React from 'react'

import { LntInput, LntSelect } from '@app/components/base'
import { TopFilters as TopFiltersWrapper } from '@app/components'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { CONTRACTORS_KEY } from '@app/constants/queryKeys'
import { SIZE } from '@app/constants'

import { getContractors } from '@app/api/routes/contractors'

import { useFiltersSearch } from '@app/hooks'

import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { commonSelectProps } from './configs'

import type { TopFilterProps } from './types'

export const TopFilters: React.FC<TopFilterProps> = ({ onSearch, initialFilters }) => {
  const {
    filters,
    canResetFilters,
    handleClearFilters,
    handleSearch,
    handleInputFilterChange,
    handleSelectFilterChange
  } = useFiltersSearch({ initialFilters, onSearch })

  return (
    <TopFiltersWrapper
      canReset={ canResetFilters }
      onClear={ handleClearFilters }
      onSearch={ handleSearch }
    >
      { /* TODO cудя по дизайну это должен быть тоже селект */ }
      <LntInput
        placeholder={ FILTERS_PLACEHOLDERS.contractorCode }
        value={ filters.id ?? '' }
        onChange={ event => handleInputFilterChange(FILTERS_PARAMS_KEYS.id, event) }
        type='number'
        size={ SIZE.middle }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.contractorIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.contractorIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.contractorsFilter }
        querySelect={ {
          queryKey: [CONTRACTORS_KEY.contractorsItems],
          queryFn: getContractors,
          select: getFilterFromEntities
        } }
      />
    </TopFiltersWrapper>
  )
}
